import axios from "@/lib/axios";

export const getAllPayments = async (params = {}) => {
  const queryString = new URLSearchParams(params).toString();
  const url = queryString ? `/payments?${queryString}` : "/payments";
  const { data } = await axios.get(url);
  return data.data;
};

export const getPayment = async (id) => {
  const { data } = await axios.get(`/payments/${id}`);
  return data.data;
};

export const createPayment = async (paymentData) => {
  const { data } = await axios.post("/payments", paymentData);
  return data.data;
};

export const updatePayment = async ({ id, ...paymentData }) => {
  const { data } = await axios.put(`/payments/${id}`, paymentData);
  return data.data;
};

export const deletePayment = async (id) => {
  const { data } = await axios.delete(`/payments/${id}`);
  return data.data;
};

export const verifyPayment = async (id) => {
  const { data } = await axios.put(`/payments/${id}/verify`);
  return data.data;
};

export const unverifyPayment = async (id) => {
  const { data } = await axios.put(`/payments/${id}/unverify`);
  return data.data;
};

export const getChapterPayments = async () => {
  const { data } = await axios.get("/payments/chapter");
  return data.data;
};

export const getPaymentStats = async () => {
  const { data } = await axios.get("/payments/stats");
  return data.data;
};

export const getFinancePayments = async () => {
  const { data } = await axios.get("/payments/finance");
  return data.data;
};
